import {
  Box,
  Container,
  Divider,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material'
import React, { memo } from 'react'
import { useCreateQuestionMulti } from '../../hooks/useCreateQuestionMulti'
import DISCAnswer from './DISCAnswer'

const DISCQuestion = memo(({ dataQuestion, indices, form }) => {
  const options = useCreateQuestionMulti(dataQuestion)

  return (
    <Box display={'flex'} flexDirection={'column'} height={'100%'} mx={'-1rem'}>
      <Box
        bgcolor={'#9AA5EA'}
        width={'100%'}
        sx={{
          borderBottomLeftRadius: '20px',
          borderBottomRightRadius: '20px',
        }}
      >
        <Divider
          sx={{
            backgroundColor: 'white',
            height: '3px',
          }}
        />
        <Box px={2} py={3}>
          <Container style={{ display: 'flex', justifyContent: 'center' }}>
            {dataQuestion.link_gambar === '' ? null : (
              <img src={dataQuestion.link_gambar} alt="img-soal" />
            )}
          </Container>
          <Typography
            textAlign={'justify'}
            fontWeight={500}
            fontSize={'14px'}
            color={'white'}
            letterSpacing={1.2}
            lineHeight={1.7}
            sx={{
              textAlign: 'center',
              whiteSpace: 'pre-wrap',
            }}
          >
            {dataQuestion.soal}
          </Typography>
        </Box>
      </Box>

      <div style={{ height: '30px' }} />

      <TableContainer height={'100%'} sx={{ borderRadius: '20px', padding: '1rem' }}>
        <Table
          container="true"
          spacing={1}
          sx={{
            backgroundColor: ({ palette }) => palette['background.2'].light,
            borderRadius: '8px',
            overflow: 'hidden',
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell>
                <Typography
                  fontWeight={700}
                  sx={{
                    color: '#fff',
                    textAlign: 'center',
                  }}
                >
                  Gambaran Diri
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  fontWeight={700}
                  sx={{
                    color: '#fff',
                    textAlign: 'center',
                  }}
                >
                  P
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  fontWeight={700}
                  sx={{
                    color: '#fff',
                    textAlign: 'center',
                  }}
                >
                  K
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody
            key={indices}
            container="true"
            sx={{
              backgroundColor: '#fff',
              marginLeft: 0,
            }}
          >
            <DISCAnswer options={options} form={form} />
          </TableBody>
        </Table>
        {/* Error dinamis dari object */}
        {Object.entries(form?.formState?.errors || {})
          .filter(([key]) => key.startsWith('p') || key.startsWith('k'))
          .map(([key, value]) => (
            <Typography key={key} color={'error'} fontSize={'12px'} sx={{ marginTop: 2 }}>
              {value?.message}
            </Typography>
          ))}
      </TableContainer>
    </Box>
  )
}, arePropEqual)

function arePropEqual(oldProps, newProps) {
  return oldProps.indices !== newProps.indices
}

export default DISCQuestion
